import {
  FETCH_PRODUCT_BRAND,
  RESET_PRODUCT_BRAND,
} from "../../constants/action.constants";

const initialState = {
  data: {},
};

const productBrandViewReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_PRODUCT_BRAND:
      return { data: action.payload };
    case RESET_PRODUCT_BRAND:
      return initialState;
    default:
      return state;
  }
};

export default productBrandViewReducer;
